import { render, staticRenderFns } from "./user-group.vue?vue&type=template&id=74d466c0&"
import script from "./user-group.vue?vue&type=script&lang=js&"
export * from "./user-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports